import { ROUTE_NAMES } from "@bakbak/common";
import { Layout } from "antd";
import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AppProvider } from "../context/AppContext";
import { HeaderProvider } from "../context/HeaderContext";
import { ForgotPasswordChangeConnector } from "../modules/auth/forgotPasswordChange/ForgotPasswordChangeConnector";
import { LoginConnector } from "../modules/auth/login/LoginConnector";
import { LogoutConnector } from "../modules/auth/logout/LogoutConnector";
import { RegisterConnector } from "../modules/auth/register/RegisterConnector";
import { SendForgotPasswordEmailConnector } from "../modules/auth/sendForgotPasswordEmail/SendForgotPasswordEmailConnector";
import { FooterConnector } from "../modules/layout/footer/FooterConnector";
import { HeaderConnector } from "../modules/layout/header/HeaderConnector";
import { CreatePostConnector } from "../modules/post/create/CreatePostConnector";
import { PostDetailsConnector } from "../modules/post/details/PostDetailsConnector";
import { ProfileConnector } from "../modules/profile/find/ProfileConnector";
import { UpdateProfileConnector } from "../modules/profile/update/UpdateProfileConnector";
import { HomePageComponet } from "../modules/screen/HomePageComponent";
import { TextPage } from "../modules/TextPage";
import { AuthRoute } from "./AuthRoute";





export const Routes = () => (
  <BrowserRouter>
    <AppProvider>
      <HeaderProvider>
        <Layout style={{ background: "#fff" }}>
          <HeaderConnector />
          <Switch>
            <Route exact={true} path={ROUTE_NAMES.HOME} component={HomePageComponet} />
            <Route
              exact={true}
              path={ROUTE_NAMES.REGISTER}
              component={RegisterConnector}
            />
            <Route
              exact={true}
              path={ROUTE_NAMES.LOGIN}
              component={LoginConnector}
            />
            <Route
              exact={true}
              path={ROUTE_NAMES.LOGOUT}
              component={LogoutConnector}
            />
            <Route
              exact={true}
              path={ROUTE_NAMES.FORGOT_PASSWORD}
              component={SendForgotPasswordEmailConnector}
            />
            <Route
              exact={true}
              path={ROUTE_NAMES.CHANGE_PASSWORD + "/:token"}
              component={ForgotPasswordChangeConnector}
            />
            <Route
              exact={true}
              path={ROUTE_NAMES.MESSAGE}
              component={TextPage}
            />
            <Route
              exact={true}
              path={ROUTE_NAMES.POST_DETAILS + "/:postId"}
              component={PostDetailsConnector}
            />

            <AuthRoute
              path={ROUTE_NAMES.CREATE_POST}
              component={CreatePostConnector}
            />
            <AuthRoute
              path={ROUTE_NAMES.MY_PROFILE}
              component={ProfileConnector}
            />
            <AuthRoute
              path={ROUTE_NAMES.EDIT_PROFILE}
              component={UpdateProfileConnector}
            />
          </Switch>
          {FooterConnector()}
        </Layout>
      </HeaderProvider>
    </AppProvider>
  </BrowserRouter>
);



// WEBPACK FOOTER //
// ./src/routes/index.tsx